<template>
  <BaseAction>
    <SecondaryButton
      @click.native="openDeleteTimesheetDialog"
      textColor="#d10a3a"
      class="timesheet-chip-style"
    >
      <v-icon>
        mdi-delete-outline
      </v-icon>
      Delete
    </SecondaryButton>
    <DeleteTimesheetDialog
      :isOpen="isDeleteTimesheetOpen"
      @close="closeDeleteTimesheetDialog"
      @onDelete="redirectToList"
      :timesheetId="id"
    />
  </BaseAction>
</template>

<script>
import DeleteTimesheetDialog from "@/views/timesheets/components/dialogs/DeleteTimesheetDialog";
import BaseAction from "@/components/common/BaseAction";
import SecondaryButton from "@/components/common/Button/SecondaryButton";

export default {
  name: "DeleteTimesheetAction",
  components: { BaseAction, SecondaryButton, DeleteTimesheetDialog },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      isDeleteTimesheetOpen: false
    };
  },
  methods: {
    openDeleteTimesheetDialog() {
      this.isDeleteTimesheetOpen = true;
    },
    closeDeleteTimesheetDialog() {
      this.isDeleteTimesheetOpen = false;
    },
    onDelete() {
      this.closeDeleteTimesheetDialog();
      this.$emit("onDelete");
    },
    redirectToList() {
      this.$router.push({ name: "timesheets" });
    }
  }
};
</script>

<style scoped lang="scss"></style>
